export const visit = (vm, at) => {
vm(require("documents-lib/lang/view/no.lyaml"));
at({ "no-no": { "public": { "sampleString": "Eksempelstreng" } } });
};